<template>
    <div class="body">
        <div class="head">
            <div class="class-name">{{className}}</div>
            <div class="time">{{nowTime[0]}} {{nowTime[2]}} {{nowTime[1]}}</div>
        </div>
        <div class="box">
            <div class="box-l">
                <div class="con box-l1">
                    <div class="title flex-bet">
                        <div class="al-center">
                            <p>
                                <el-image style="width: 60px; height: 60px"
                                          :src="require('../../assets/imgs/classStatisticsImgs/badge.png')"></el-image>
                            </p>
                            <p class="p10">班级慧正指数</p>
                        </div>
                        <div class="al-center">
                            <el-date-picker
                                    v-model="months"
                                    type="month"
                                    value-format="yyyy-MM-dd"
                                    align="center"
                                    @change="getStatistical()"
                                    placeholder="选择月">
                            </el-date-picker>
                        </div>
                    </div>
                    <div id="myEcharts1" class="echartBox"></div>
                </div>
                <div class="con minH-470">
                    <div class="title flex-bet">
                        <div class="al-center">
                            <p>
                                <el-image style="width: 60px; height: 60px"
                                          :src="require('../../assets/imgs/classStatisticsImgs/flag.png')"></el-image>
                            </p>
                            <p class="p10">清新班级</p>
                        </div>
                        <div class="weekTime al-center">{{currentWeek}}</div>
                    </div>

                    <div class="weekClass">
                        <div class="weekClass-box">
                            <div class="rank" v-for="(item,index) in weekClass" :key="index">
                                <div>{{item.week}}</div>
                                <div :class="item.count?'star star-n':'star star-o'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div :class="lookMore?'chunk box-r1 h100':'chunk box-r1 h260'">
                    <div class="big-title al-center">
                        <p>
                            <el-image style="width: 60px; height: 60px"
                                      :src="require('../../assets/imgs/classStatisticsImgs/people.png')"></el-image>
                        </p>
                        <span class="fl p10">学生个人慧正指数</span>
                        <button class="blue-btn" @click="lookMore=!lookMore">查看更多</button>
                        <div style="flex: 1;"></div>
                        <ul class="select-wrap">
                            <li>
                                <i :class="item.type==pointType?'active':''" v-for="(item,idx) in typeList" :key="idx"
                                   @click="getPointTop(item.type)">{{item.name}}</i>
                            </li>
                        </ul>
                    </div>
                    <div :class="lookMore?'autoHeight':''">
                        <div class="students">
                            <div class="stu-box" v-for="(item,index) in studentList" :key="index"
                                 @click="studentClick(item)">
                                <div class="rankBg firstBg" v-if="index==0"></div>
                                <div class="rankBg twoBg" v-if="index==1"></div>
                                <div class="rankBg threeBg" v-if="index==2"></div>
                                <div :class="['stu-t', showStudent.studentId==item.studentId?'studentActive':'']">
                                    {{item.name}}
                                </div>
                                <div class="stu-c">{{item.name}}</div>
                                <div class="stu-b">{{item.prizeValue}}星</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div :class="lookMore?'hid':'box-r2'">
                    <div class="chunk growUp">
                        <div class="title2">
                            <span>我的发展成长图</span>
                            <ul class="select-wrap">
                                <li>
                                    <i :class="item.type==developTimeType?'active':''" v-for="(item,idx) in typeList"
                                       :key="idx"
                                       @click="getPrizeGrouop(item.type)">{{item.name}}</i>
                                </li>
                            </ul>
                        </div>
                        <div class="growUp-c">
                            <div class="growUp-b">
                                <div class="tip">获得奖卡</div>
                                <div id="myEcharts2" class="echartBox"></div>
                            </div>
                            <div class="growUp-b">
                                <div class="tip">维度分析</div>
                                <div id="myEcharts3" class="echartBox"></div>
                            </div>
                        </div>
                    </div>
                    <div class="chunk">
                        <div class="title2">
                            <span>我的亮点时刻</span>
                            <ul class="select-wrap">
                                <li>
                                    <i :class="item.type==lightspotTiemType?'active':''" v-for="(item,idx) in typeList"
                                       :key="idx"
                                       @click="getExchangeTop(item.type)">{{item.name}}</i>
                                </li>
                            </ul>
                        </div>
                        <div class="light-body">
                            <el-empty description="暂无数据" v-if="topList.length==0"></el-empty>

                            <div>
                                <div class="block" v-for="(item,index) in topList" :key="index">
                                    <div class="block-l">
                                        <div class="img">
                                            <el-image
                                                    style="width: 175px; height: 110px"
                                                    :src="item.prizeIcon.url||require('../../assets/imgs/classStatisticsImgs/bi.png')">
                                            </el-image>
                                        </div>
                                        <div class="block-lc">
                                            <div>{{item.time}}</div>
                                            <div>{{item.studentName}}</div>
                                            <div>获得{{item.prizeName}}</div>
                                        </div>
                                    </div>
                                    <div class="block-r">
                                        +{{item.inner}} 分
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "classStatistics",
        data() {
            return {
                nowTime: [],
                // classId: '323995031863296',
                // schoolId: '323965577035776',
                // topicId: '545828777984000',
                classId: '',
                schoolId: '',
                topicId: '',
                className: '',
                nowDate: '',
                months: '',
                typeList: [
                    {name: '今日', type: 1},
                    {name: '本周', type: 2},
                    {name: '本月', type: 3},
                ],
                pointType: 3,
                lookMore: false,
                studentList: [],
                showStudent: {},
                developTimeType: 3,
                lightspotTiemType: 3,
                topList: [],
                weekClass: [],
                currentWeek: '',
                myEcharts1: null,
                myEcharts2: null,
                myEcharts3: null,

                rocessVersion: '',
            }
        },
        created() {
            this.classId = this.$route.query.classId
            this.schoolId = this.$route.query.schoolId
            this.topicId = this.$route.query.topicId
            this.getClass()
            this.months = this.$util.getNowDate()
            this.nowDate = this.$util.getNowDate()
            this.getPointTop(this.pointType)
            this.nowTimes()
            this.getWeekClass() //清新班级

        },
        mounted() {
            this.getStatistical()
            window.onresize = () => {
                this.myEcharts1.resize();
                this.myEcharts2.resize();
                this.myEcharts3.resize();
            };
        },
        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = [];
                this.nowTime.push(year + "年" + month + "月" + date + '日');
                this.nowTime.push(hh + ":" + mm + ':' + ss);
                let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                this.nowTime.push(weeks[timeStamp.getDay()]);
            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },
            getClass() {
                let url = "/zuhu1/api-dashboard/class/findById"
                this.$api.post(url, {classId: this.classId}, response => {
                    if (response.data.result == "success") {
                        this.className = response.data.data.className
                    }
                })
            },
            getStatistical() {
                let url = "/zuhu1/api-dashboard/exchange/prize46Group"
                let query = {
                    openid: "abc",
                    schoolId: this.schoolId,
                    classId: this.classId
                }
                query.startTime = this.$util.monthFirstDay(this.months)
                query.endTime = this.$util.monthLastDay(this.months) + ' 23:59:59'
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        datas.map(item => {
                            item.name = item.prizeName
                            item.value = item.quantity
                        })
                        this.statistics(datas)
                    }
                })
            },
            //统计图
            statistics(datas) {
                this.myEcharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myEcharts1.setOption({
                    color: ['#5087EC', '#68BBC4', '#EE752F', '#58A55C', '#F2BD42', '#F7F401'],
                    title: {
                        text: '基础卡',
                        right: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        right: '0',
                        top: '20%'
                    },
                    series: [
                        {
                            name: '基础卡',
                            type: 'pie',
                            radius: '50%',
                            data: datas,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
            },

            //学生个人指数
            getPointTop(type) {
                this.pointType = type
                let nowDate = this.nowDate
                let url = "/zuhu1/api-dashboard/exchange/rankByClassId"
                let query = {
                    openid: "abc",
                    schoolId: this.schoolId,
                    classId: this.classId,
                }
                switch (type * 1) {
                    case 1:
                        query.startTime = nowDate
                        query.endTime = nowDate + ' 23:59:59'
                        break;
                    case 2:
                        query.startTime = this.$util.weekFirstDay(nowDate)
                        query.endTime = this.$util.weekLastDay(nowDate) + ' 23:59:59'
                        break;
                    case 3:
                        query.startTime = this.$util.monthFirstDay(nowDate)
                        query.endTime = this.$util.monthLastDay(nowDate) + ' 23:59:59'
                        break;
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        this.studentList = response.data.data || []
                        this.setTimeStudent()
                    }
                })

            },

            setTimeStudent() {
                this.setStudent()
                setInterval(this.setTimeStudent, 30000);
                this.studentclear()
            },
            studentclear() {
                clearInterval(this.setTimeStudent)
                this.setTimeStudent = null;
            },
            setStudent() {
                let studentList = this.studentList
                let randomNumber = Math.floor(Math.random() * studentList.length)
                let student = studentList[randomNumber]
                this.studentClick(student)
            },
            studentClick(item) {
                this.showStudent = item
                this.getPrizeGrouop(this.developTimeType)
                this.getExchangeTop(this.lightspotTiemType)
            },

            getPrizeGrouop(type) {
                this.developTimeType = type
                let nowDate = this.nowDate
                let query = {
                    openid: "abc",
                    schoolId: this.schoolId,
                    classId: this.classId,
                    studentId: this.showStudent.studentId
                }

                switch (type * 1) {
                    case 1:
                        query.startTime = nowDate + ' 00:00:00'
                        query.endTime = nowDate + ' 23:59:59'
                        break;
                    case 2:
                        query.startTime = this.$util.weekFirstDay(nowDate) + ' 00:00:00'
                        query.endTime = this.$util.weekLastDay(nowDate) + ' 23:59:59'
                        break;
                    case 3:
                        query.startTime = this.$util.monthFirstDay(nowDate) + ' 00:00:00'
                        query.endTime = this.$util.monthLastDay(nowDate) + ' 23:59:59'
                        break;
                }
                this.getPrize(query)
                this.getVersion(query) //获取版本号
            },
            // 获得奖卡
            getPrize(query) {
                let url = "/zuhu1/api-dashboard/exchange/prize46Group"
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data

                        let obj = {
                            x: [],
                            y: [],
                        }
                        datas.map(item => {
                            obj.x.push(item.prizeName)
                            obj.y.push(item.quantity)
                        })
                        this.statisticsBar(obj)
                    }
                })

            },
            statisticsBar(datas) {
                this.myEcharts2 = this.$echarts.init(document.getElementById('myEcharts2'))
                // 绘制图表
                this.myEcharts2.setOption({
                    color: ['#539DFE'],
                    tooltip: {
                        trigger: 'axis',
                    },
                    xAxis: {
                        type: 'category',
                        data: datas.x
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: datas.y,
                            type: 'bar',
                            barWidth: 25,
                        }
                    ]
                })
            },

            // 维度分析
            getDimensionality(query) {
                let url = "/zuhu1/api-dashboard/evaluateStandard/firstLevelQuota"
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        let value = [], indicator = []
                        datas.map(item => {
                            value.push(item.number)
                        })
                        let max = Math.max.apply(null, value)
                        max = max == 0 ? '10' : max
                        datas.map(item => {
                            let obj = {
                                name: item.name,
                                max: max,
                            }
                            indicator.push(obj)
                        })

                        let showStudent = this.showStudent
                        this.studentList.map(item => {
                            if (item.studentId == showStudent.studentId) {
                                item.cacheData = {
                                    indicator: indicator,
                                    value: value
                                }
                            }
                        })
                        this.statisticsRandar(indicator, value)


                    }
                })
            },
            statisticsRandar(indicator, value) {
                this.myEcharts3 = this.$echarts.init(document.getElementById('myEcharts3'))
                // 绘制图表
                this.myEcharts3.setOption({
                    radar: {
                        indicator: indicator,
                    },
                    series: [
                        {
                            name: '维度',
                            type: 'radar',
                            label: {
                                show: true
                            },
                            data: [
                                {
                                    value: value,
                                }
                            ]
                        }
                    ]
                })
            },


            // 我的亮点时刻
            getExchangeTop(type) {
                this.lightspotTiemType = type
                let nowDate = this.nowDate
                let url = "/zuhu1/api-dashboard/exchange/top"
                let query = {
                    openid: "abc",
                    schoolId: this.schoolId,
                    studentId: this.showStudent.studentId,
                    page: 1,
                    size: 10
                }
                switch (type * 1) {
                    case 1:
                        query.startTime = nowDate
                        query.endTime = nowDate + ' 23:59:59'
                        break;
                    case 2:
                        query.startTime = this.$util.weekFirstDay(nowDate)
                        query.endTime = this.$util.weekLastDay(nowDate) + ' 23:59:59'
                        break;
                    case 3:
                        query.startTime = this.$util.monthFirstDay(nowDate)
                        query.endTime = this.$util.monthLastDay(nowDate) + ' 23:59:59'
                        break;
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || []
                        datas.map(item => {
                            item.prizeIcon = item.prizeIcons[0] || {}
                            let prizeIcons = item.prizeIcons || []
                            // 多个取正面 0反面 1正面（默认）
                            prizeIcons.map(item1 => {
                                if (item1.type == 1) {
                                    item.prizeIcon = item1
                                }
                            })
                            item.inner = item.prizeInners[0].quantity || 0
                            item.time = item.createTime.substring(0, 11)
                        })
                        this.topList = datas
                    }
                })
            },

            // 清新班级
            getWeekClass() {
                let url = "/zuhu1/api-dashboard/topicAnswer/weekByClassAndTopic"
                let query = {
                    classId: this.classId,
                    topicId: this.topicId
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || {}
                        this.weekClass = datas.l
                        this.currentWeek = datas.currentWeek
                    }
                })
            },

            getVersion(queryData) {
                let url = "/zuhu1/api-dashboard/evaluateContentProcessFormData/version"
                let query = {
                    openid: "abc",
                    schoolId: this.schoolId,
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || ''
                        if (this.rocessVersion == datas) {
                            let showStudent = this.showStudent
                            this.studentList.map(item => {
                                if (item.studentId == showStudent.studentId) {
                                    let cacheData = item.cacheData
                                    if (cacheData) {
                                        this.statisticsRandar(cacheData.indicator, cacheData.value)
                                    } else {
                                        this.getDimensionality(queryData)
                                    }
                                }
                            })
                        } else {
                            this.rocessVersion = datas
                            this.getDimensionality(queryData)
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .body {
        background: #0F40F5;
        width: 100%;
        height: 100%;
        background-image: url(../../assets/imgs/classStatisticsImgs/bodybg.jpg);
        background-repeat: no-repeat;
    }

    .head {
        color: white;
        display: flex;
        justify-content: space-between;
        height: 100px;
        line-height: 100px;
    }

    .head > div {
        padding: 0 24px;
    }

    .class-name {
        font-size: 36px;
    }

    .time {
        font-size: 20px;
    }

    .title {
        font-size: 24px;
        color: #333333;
    }

    .title2 {
        font-size: 22px;
    }


    .chunk {
        border-radius: 20px;
        background: white;
        padding: 20px;
    }

    .box {
        box-sizing: border-box;
        padding: 0 40px 40px;
        height: calc(100% - 100px);
        display: flex;
        justify-content: space-between;
    }

    .box-l {
        background: white;
        border-radius: 20px;
        width: 38%;
        height: 100%;
    }

    .box-l1 {
        height: calc(100% - 470px);
    }

    .con {
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
    }

    .echartBox {
        flex: 1;
    }

    .box-r {
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .box-r1 {
        height: 250px;
        overflow: hidden;
    }

    .students {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

    .stu-box {
        width: 85px;
        text-align: center;
        display: inline-block;
        margin: 0 40px 30px 0;
        position: relative;
    }

    .rankBg {
        width: 120px;
        height: 120px;
        background-size: cover;
        position: absolute;
        top: -23px;
        left: -19px;
    }

    .firstBg {
        background-image: url(../../assets/imgs/classStatisticsImgs/firstBg.png);
    }

    .twoBg {
        background-image: url(../../assets/imgs/classStatisticsImgs/twoBg.png);
    }

    .threeBg {
        background-image: url(../../assets/imgs/classStatisticsImgs/threeBg.png);
    }

    .stu-t {
        width: 75px;
        height: 75px;
        line-height: 75px;
        background: #529CFD;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        margin: auto;
        font-size: 20px;
    }

    .stu-c {
        margin-top: 10px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .stu-b {
        height: 40px;
        line-height: 40px;
        font-size: 28px;
        overflow: hidden;
        color: #fd8e3e;
        white-space: nowrap;
    }


    .box-r2 {
        height: calc(100% - 290px);
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
    }

    .box-r2 > div {
        width: 45%;
    }

    .growUp {
        display: flex;
        flex-direction: column;
    }

    .growUp-c {
        flex: 1;
    }

    .growUp-b {
        height: 50%;
    }


    .flex-bet {
        display: flex;
        justify-content: space-between;
    }

    .big-title span {
        font-size: 24px;
        color: #333;
        margin: 0 10px;
    }

    .fl {
        float: left;
    }

    .blue-btn {
        padding: 5px 15px;
        color: #fff;
        background: #3e94ff;
        border-radius: 15px;
        border: none;
        outline: none;
        margin-top: 2px;
    }

    .select-wrap {
        float: right;
        font-size: 16px;
        padding: 0 15px;
    }

    ul {
        list-style: none;
    }

    li {
        display: list-item;
    }

    li i {
        float: left;
        padding: 5px 15px;
        color: #3e94ff;
        background: #f0f4ff;
        border-radius: 15px;
        margin-left: 10px;
        font-style: normal;
    }

    li i.active {
        color: #fff;
        background: #3e94ff;
    }

    .hid {
        display: none;
    }

    .h100 {
        height: 100% !important;
    }


    .growUp-b {
        display: flex;
    }

    .tip {
        display: block;
        background: #F8DD14;
        border-radius: 10px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 22px;
        margin: 10px 0 0;
        width: 110px;
    }

    .light-body {
        width: 100%;
        height: calc(100% - 30px);
        overflow: auto;
        padding: 10px 0;
        box-sizing: border-box;
    }

    .light-body::-webkit-scrollbar {
        width: 4px;
    }

    .light-body::-webkit-scrollbar-thumb {
        border-radius: 10px;
        /*opacity: 0;*/
        background: rgba(0, 92, 225, 0.5);
    }


    .block {
        width: 460px;
        height: 160px;
        background-image: url(../../assets/imgs/classStatisticsImgs/ticket.png);
        background-repeat: no-repeat;
        margin: 20px auto;
        display: flex;
    }

    .block-l {
        width: 69%;
        height: 160px;
        display: flex;
        padding: 25px 10px;
        box-sizing: border-box;
    }

    .img {
        width: 175px;
        height: 110px;
    }

    .img > image {
        width: 100%;
        height: 100%;
    }


    .block-lc {
        flex: 1;
    }

    .block-lc > div {
        width: 126px;
        height: 36px;
        line-height: 36px;
        padding: 0 10px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .block-r {
        width: 31%;
        height: 160px;
        line-height: 160px;
        text-align: center;
        color: rgb(210, 2, 2);
        font-size: 28px;
        font-weight: bold;
    }

    /*清新班级*/
    .weekClass {
        width: 270px;
        height: 370px;
        background-image: url(../../assets/imgs/classStatisticsImgs/dewClassBg.png);
        background-size: cover;
        background-repeat: no-repeat;
        margin: auto;
    }

    .minH-470 {
        height: 470px !important;
    }

    .weekClass-box {
        width: 194px;
        height: 250px;
        border: 1px solid red;
        margin: 88px auto 0;
        padding: 10px;
        box-sizing: border-box;
    }

    .rank {
        display: inline-block;
        width: 20%;
        text-align: center;
        margin: 4px 0;
    }

    .star {
        width: 25px;
        height: 25px;
        background-repeat: no-repeat;
        background-size: cover;
        margin: auto;
    }

    .star-n {
        background-image: url("../../assets/imgs/classStatisticsImgs/star-n.png");
    }

    .star-o {
        background-image: url("../../assets/imgs/classStatisticsImgs/star.png");
    }

    .weekTime {
        font-size: 16px;
        color: rgb(61, 61, 61);
    }

    .al-center {
        display: flex;
        align-items: center;
    }

    .p10 {
        padding: 0 5px;
    }

    .studentActive {
        background: rgb(0, 72, 206) !important;
    }

    .autoHeight {
        width: 100%;
        height: calc(100% - 64px);
        overflow: auto;
    }

    .autoHeight::-webkit-scrollbar {
        width: 4px;
    }

    .autoHeight::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 92, 225, 0.5);
    }
</style>
